import type { ReactNode } from "react";
import { BrowserRouter } from "react-router-dom";
import { ParentContext } from "components/constants/ParentContext";
import { useAppState } from "hook/useAppState";

interface AppProviderProps {
  children: ReactNode;
  isHarbour: boolean;
  isBiz4Biz: boolean;
}

export function AppProvider({
  children,
  isHarbour,
  isBiz4Biz,
}: AppProviderProps) {
  const appState = useAppState();

  return (
    <ParentContext.Provider
      value={{
        isHarbour: isHarbour ?? appState.isHarbourClub,
        isBiz4Biz: isBiz4Biz ?? appState.isBiz4Biz,
        tutorialStep: appState.tutorialStep,
        setTutorialStep: appState.setTutorialStep,
      }}
    >
      <BrowserRouter>{children}</BrowserRouter>
    </ParentContext.Provider>
  );
}
